/* 
 * NOTICE OF LICENSE
 * 
 * This source file is subject to the Academic Free License (AFL 3.0)
 * 
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2019 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import $ from 'jquery';

( function() {
    
    if( $('.page-header--services-single').length ){
            
          
        var circle1 = gsap.timeline({repeat: -1});
            circle1.to(".js-services-single-circle-2", {x: 10, y: -10, duration: 12, ease: 'none'});
            circle1.to(".js-services-single-circle-2", {x: 40, y: 30, duration: 16, ease: 'none'});
            circle1.to(".js-services-single-circle-2", {x: 20, y: 70, duration: 21, ease: 'none'});
            circle1.to(".js-services-single-circle-2", {x: -20, y: 40, duration: 17, ease: 'none'});
            circle1.to(".js-services-single-circle-2", {x: 0, y: 0, duration: 9, ease: 'none'});

        circle1.pause();
        $('.js-services-single-circle-2').hover(function () {          
            circle1.pause();
        },function (e) {
            circle1.resume();
        });

        var circle3 = gsap.timeline({repeat: -1});
            circle3.to(".js-services-single-circle-3", {x: 10, y: 20, duration: 19, ease: 'none'});
            circle3.to(".js-services-single-circle-3", {x: -40, y: 40, duration: 10, ease: 'none'});
            circle3.to(".js-services-single-circle-3", {x: 20, y: -70, duration: 17, ease: 'none'});
            circle3.to(".js-services-single-circle-3", {x: 40, y: 40, duration: 21, ease: 'none'});
            circle3.to(".js-services-single-circle-3", {x: 0, y: 0, duration: 13, ease: 'none'});

        circle3.pause();
        $('.js-services-single-circle-3').hover(function () {          
            circle3.pause();
        },function (e) {
            circle3.resume();
        });


        circle1.resume();
        circle3.resume();
        $('.js-services-single-white').addClass('active');
        $('.js-services-single-red').addClass('active');


    }
    
} )();